import { User } from "lucide-react";

import { Button } from "~/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "~/components/ui/dropdown-menu";
import { useOptimizedSellers } from "~/hooks/useOptimizedProfiles";

interface SellerFilterProps {
  value: string;
  onChange: (value: string) => void;
}

const SellerFilter = ({ value, onChange }: SellerFilterProps) => {
  const { sellers, isLoading, error } = useOptimizedSellers();

  // Get display name for the current filter value
  const getSelectedSellerName = () => {
    if (value === "all") return "Todos los vendedores";
    if (value === "unassigned") return "Sin vendedor asignado";

    const seller = sellers.find((s) => s.id === value);
    return seller ? seller.full_name : "Vendedor seleccionado";
  };

  const handleSellerSelect = (sellerId: string) => {
    onChange(sellerId);
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm" className="h-9 sm:max-w-[220px]">
          <User className="mr-2 h-4 w-4 shrink-0" />
          <span className="truncate">
            {isLoading ? "Cargando..." : getSelectedSellerName()}
          </span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-[260px]">
        <DropdownMenuLabel>Filtrar por vendedor</DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={() => handleSellerSelect("all")}>
          Todos los vendedores
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => handleSellerSelect("unassigned")}>
          Sin vendedor asignado
        </DropdownMenuItem>
        {sellers.length > 0 && <DropdownMenuSeparator />}
        <div className="max-h-[200px] overflow-y-auto">
          {sellers.map((seller) => (
            <DropdownMenuItem
              key={seller.id}
              onClick={() => handleSellerSelect(seller.id)}
            >
              {seller.full_name}
            </DropdownMenuItem>
          ))}
        </div>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default SellerFilter;
